import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import Logo from "../images/logo.png";
import { RiArrowGoBackLine } from 'react-icons/ri';
import axios from 'axios';
import { buildApiUrl } from "../utils/api";

function Clientlogin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [otp, setOtp] = useState('');
    const [isOtpSent, setIsOtpSent] = useState(false);
    const navigate = useNavigate();

    const requestOtp = async () => {
        try {
            await axios.post(buildApiUrl('/api/client/send-otp'), { email });
            setIsOtpSent(true);
            alert('OTP has been sent to your email.');
        } catch (err) {
            console.error('Error sending OTP:', err);
            setError('Failed to send OTP. Please try again.');
        }
    };

    const verifyOtp = async () => {
        setLoading(true);
        setError(null);

        try {
            const otpResponse = await axios.post(buildApiUrl('/api/client/verify-otp'), { email, otp });
            console.log(otpResponse.data.message);

            if (otpResponse.status === 200) {
                alert('OTP verified successfully! You can now log in.');
                // localStorage.setItem('token', response.data.token);
                // navigate('/clientDetails');
            }
        } catch (err) {
            console.error('OTP verification failed:', err);
            setError('Invalid OTP. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        //console.log('Email:', email);  // Log email
        // console.log('Password:', password);  // Log password

        try {
            const response = await axios.post(buildApiUrl('/api/client/login'), { email, password });
            // console.log('Login successful!', response.data);
            const userType = "Client";
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('userType', userType);
            navigate('/clientDetails');
        } catch (err) {
            console.error('Login failed:', err.response.data); // Log the error response
            setError('Invalid credentials. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="clientLogin">
                <img src={Logo} alt="logo" style={{ height: "80px", marginTop: "20px" }} />
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "80vh", width: "100%" }} // Full width and height of the viewport
                >
                    <div className="row text-start" style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                        <form
                            onSubmit={handleLogin}
                            className="login-form"
                            style={{
                                padding: "2rem 6rem",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "8px",
                                opacity: "0.7",
                                width: "80%",
                                maxWidth: "500px" // Limit the form's width
                            }}
                        >
                            <h2 className="text-center mb-4" style={{ color: "#973131" }}>Client Login</h2>

                            {error && <div className="alert alert-danger" role="alert">{error}</div>}

                            <div className="mb-3">
                                <label htmlFor="exampleInputEmail1" className="form-label">Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="exampleInputEmail1"
                                    placeholder="Your E-mail"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label htmlFor="exampleInputPassword1" className="form-label">Password</label>
                                <div className="input-group">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        className="form-control"
                                        id="exampleInputPassword1"
                                        placeholder="Enter Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="d-flex align-items-center mt-2">
                                    <input
                                        type="checkbox"
                                        id="showPassword"
                                        onClick={() => setShowPassword(!showPassword)}
                                    />
                                    <label htmlFor="showPassword" className="ms-2">
                                        {showPassword ? "Hide Password" : "Show Password"}
                                    </label>
                                </div>
                            </div>

                            {!isOtpSent ? (
                                <button type="button" className="btn btn-secondary" onClick={requestOtp}>
                                    Request OTP
                                </button>
                            ) : (
                                <div className="mb-3">
                                    <label htmlFor="otpInput" className="form-label">Enter OTP</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="otpInput"
                                        placeholder="Enter OTP"
                                        value={otp}
                                        onChange={(e) => setOtp(e.target.value)}
                                        required
                                    />
                                    <button type="button" className="btn btn-secondary mt-2" onClick={verifyOtp}>
                                        Verify OTP
                                    </button>
                                </div>
                            )}

                            {isOtpSent && (
                                <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                                    {loading ? "Logging in..." : "Submit"}
                                </button>
                            )}

                            <div className="d-flex justify-content-center mt-3">
                                <p>Create New Account | <Link to="/registerClient">Sign Up here</Link></p>
                            </div>

                            <div className="d-flex justify-content-center mt-2">
                                <p><Link to="/" style={{ textDecoration: "none", color: "#000" }}><RiArrowGoBackLine /> Go Back to Home Page</Link></p>
                            </div>
                        </form>
                    </div>
                </div>


            </div>
        </>
    )
}

export default Clientlogin;
